
function Website() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Collection.Website visual. <br/>
    /// It loads the preview and sends the data to the server
    /// <br/>
    /// Author: MWI<br />
    /// Date: 10.03.2016<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.2 - 05.04.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - improved Error Handling and all methods only have 1 return statement*<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 30.03.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - changed resources and notification if it is not yet added to fav *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 10.03.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    // the following attributes got set in Charts.Collection.Website.vb
    this.day = "";
    this.source = "Widget.Collection.Website.js.";
}

Website.prototype = new window.vcTemplate();

Website.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it does nothing more than adding the clickhandler 
    /// </summary>
    var me = this;
    var bRet = true;
    try {

        if (me.error) {
            bRet = false;
        } else {

            me.showInfo("", "", false);
           
            if (me.vcgid.indexOf("tpl")>=0) {
                //me.showInfo(me.resources.addChart, false);
                me.visual.append("<div style='font-size:1.4em; font-weight:bold; margin: 10px 0;'>" + me.resources.addWebsiteToFavoritesFirstHeader_lbl + "</div>");
                me.visual.append("<p>" + me.resources.addWebsiteWidgetFirstToFavorites_lbl + "</p>");
            } else {
                me.visual.find('.hidden').removeClass("hidden");
                me.visual.find('#divBtnSave').on("click", function() {
                    me.save();
                });
             

                me.visual.find('#txtURL').off("change, keyup").on("change, keyup", function() {
                    me.showPreview();

                });
            }
        }
      } catch (ex) {
        me.writeError(me.source+'init', ex);
        bRet = false;
    }
    return bRet;

};

Website.prototype.showPreview = function() {
    /// <summary>
    /// This function sets the URL of the preview if it is valid <br/>
    /// </summary>
    var me = this;
    var bRet = true;
    try {
        if (me.error) {
            bRet = false;
        } else {
            if (me.validUrl()) {
                me.visual.find("#divBtnPreview").attr("href", me.visual.find("#txtURL").val());
                me.visual.find("#divBtnSave").addClass("active");
            }

        }
    } catch (ex) {
        me.writeError(me.source + 'showPreview', ex);
        bRet = false;
    }
    return bRet;
};

Website.prototype.save = function () {
    /// <summary>
    /// This function sends the URL to the server for saving  if it is valid <br/>
    /// </summary>
    var me = this;
    var bRet = true;
    try {
        if (me.error) {
            bRet = false;
        } else {
            if (me.validUrl()) {
                window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', 2, 2, JSON.stringify({ url: me.visual.find("#txtURL").val(), FavoritesID: parseInt(me.vcgid.replace("favItem", ""), 10) }),
                    function (result) {
                        var resObj = JSON.parse(result);
                        me.showInfo(resObj.returnHtml, "", resObj.hasError);
                    });

            }
        }
    } catch (ex) {
        me.writeError(me.source + 'save', ex);
        return false;
    }
    return bRet;
    //window.open(url);
};

Website.prototype.validUrl = function () {
    /// <summary>
    /// This function does the main part and validates the URL <br/>
    /// it uses a regular expression to check for valid URL (taken from http://stackoverflow.com/questions/6927719/url-regex-does-not-work-in-javascript) <br/>
    /// it checks for possibly insecure (only Http) websites and issues a warning <br />
    /// </summary>
    var me = this;
    var bRet = true;
    try {
        if (me.error) {
            bRet = false;
        } else {
            var regexpUrl = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/i;
            var bHttpWarning = false;
            // var testRegexOnlyHttp = new RegExp(regexponlyHttp);
            var testPureUrl = new RegExp(regexpUrl);
            if (me.visual.find("#txtURL").val().trim().indexOf("http://") >= 0) {
                me.showInfo(me.resources.unencryptedWebsite, false);
                bHttpWarning = true;
            } else {
                me.showInfo("", "", false);
            }
            if (me.visual.find("#txtURL").val().trim().length > 0 && testPureUrl.test(me.visual.find("#txtURL").val().trim()) === true) {
                if (bHttpWarning) {
                    me.showInfo(me.resources.unencryptedWebsite, "", false);
                } else {
                    me.showInfo("", "", false);
                }
            } else {
                if (me.visual.find("#txtURL").val().trim().length > 0) {
                    me.showInfo(me.resources.invalidUrl, "", false);
                } else {
                    me.showInfo(me.resources.emptyUrl, "", false);
                }
                bRet = false;
            }
        }
    } catch (ex) {
        me.writeError(me.source + 'validUrl', ex);
         bRet = false;
    }
    return bRet;
};